module.exports = {"production":true,"beta":true}


//////////////////
// WEBPACK FOOTER
// ./config/prodEnvs.json
// module id = 5Dgt
// module chunks = 53